export class SceneryStep {
    Id?: number;
    Name: string;
    Description?: string;
    DeviceId?: number;
    SceneryId: number;
    DeviceName?: string;
    DeviceDescription?: string;
    Index?: number;

    constructor(sceneryId: number) {
        this.SceneryId = sceneryId;
        this.Name = '';
        this.Description = '';
    }
}
